import React, { useEffect, useState } from "react";
import { IAutomationMailWorkerEdit } from "../../../interfaces/IAutomationMail";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Card,
    CardContent,
    Grid,
    IconButton,
    MenuItem,
    TextField,
    Typography,
} from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { CustomEditor } from "../../core/CustomEditor";
import { CustomeTextField } from "../../core/CustomeTextField";
import { Close, RotateLeft } from "@mui/icons-material";

interface IProps {
    automationMailWorkerEdit: IAutomationMailWorkerEdit;
    automationMailWorkerEditArray: IAutomationMailWorkerEdit[];
    setAutomationMailWorkerEditArray: Function;
}

export const AutomationMailWorkerEditAccordion: React.FC<IProps> = ({
    automationMailWorkerEdit,
    automationMailWorkerEditArray,
    setAutomationMailWorkerEditArray,
}) => {
    const [autoMail, setAutoMail] = useState(automationMailWorkerEdit);

    useEffect(() => {
        setAutomationMailWorkerEditArray([
            ...automationMailWorkerEditArray.map((mail) => (mail.id === autoMail.id ? autoMail : mail)),
        ]);
    }, [autoMail]);

    const setText = (txt: string) => {
        setAutoMail({ ...autoMail!, body: txt });
    };

    if (autoMail.is_send == false) {
        return (
            <>
                <Card variant="outlined">
                    <CardContent>
                        <Typography component="span">{autoMail.title}</Typography>
                        <IconButton
                            title="Senden der E-Mail reaktivieren"
                            onClick={() =>
                                setAutoMail({
                                    ...autoMail,
                                    is_send: true,
                                })
                            }
                            sx={{ float: "right" }}
                        >
                            <RotateLeft />
                        </IconButton>
                    </CardContent>
                </Card>
            </>
        );
    }

    return (
        <>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                    <Typography component="span">{autoMail.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <>
                        <IconButton
                            title="Senden der E-Mail deaktivieren"
                            onClick={() =>
                                setAutoMail({
                                    ...autoMail,
                                    is_send: false,
                                })
                            }
                            sx={{ float: "right" }}
                        >
                            <Close />
                        </IconButton>

                        <Grid container spacing={2}>
                            {(autoMail.is_edit_send_from == true) &&
                                <Grid item sm={4}>
                                    <CustomeTextField
                                        attr="send_from"
                                        label="Senden von"
                                        object={autoMail}
                                        setObject={setAutoMail}
                                        type="select"
                                    >
                                        {[
                                            {
                                                id: 1,
                                                label: "Mir",
                                            },
                                            {
                                                id: 2,
                                                label: "Innendienst",
                                            },
                                            {
                                                id: 3,
                                                label: "Außendienst",
                                            },
                                            {
                                                id: 4,
                                                label: "Bauleitung",
                                            },
                                            {
                                                id: 5,
                                                label: "System",
                                            },
                                        ].map((entry) => (
                                            <MenuItem key={`send-from-option-${entry.id}`} value={entry.id}>
                                                {entry.label}
                                            </MenuItem>
                                        ))}
                                    </CustomeTextField>
                                </Grid>
                            }

                            <Grid item sm={(autoMail.is_edit_send_from == true) ? 8 : 12}>
                                <TextField
                                    label="Betreff"
                                    size="small"
                                    value={autoMail.subject}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                        setAutoMail({ ...autoMail, subject: event.target.value })
                                    }
                                    error={autoMail.subject === ""}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <CustomEditor
                                txt={autoMail.body}
                                setTxt={setText}
                                dictonaryIdsArray={[]}
                                dictionaryEntryArray={[]}
                            />
                        </Grid>
                    </>
                </AccordionDetails>
            </Accordion>
        </>
    );
};
